import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';

import { bp } from '@/styles';

import ComplianceLinks from './ComplianceLinks';
import LegRegLinks from './LegRegLinks';
import NewsLinks from './NewsLinks';
import RelatedInfoLinks from './RelatedInfoLinks';

const style = {
  cards: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    @media ${bp.md} {
      flex-direction: row;
    }
    @media print {
      display: none;
    }
  `,
};

function StateLinks({ stateCode, loading, relatedLinks }) {
  return loading ? null : (
    <div css={style.cards}>
      <NewsLinks stateCode={stateCode} />
      <ComplianceLinks stateCode={stateCode} />
      <LegRegLinks stateCode={stateCode} />
      <RelatedInfoLinks relInfoLinks={relatedLinks} />
    </div>
  );
}

StateLinks.propTypes = {
  stateCode: PropTypes.string.isRequired,
};

export default StateLinks;
